import { render, staticRenderFns } from "./OrderAdmittanceAdmittingAndSenior.vue?vue&type=template&id=6c829a0e&scoped=true&"
import script from "./OrderAdmittanceAdmittingAndSenior.vue?vue&type=script&lang=js&"
export * from "./OrderAdmittanceAdmittingAndSenior.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c829a0e",
  null
  
)

export default component.exports
import {QItem,QInput,QBtn,QTooltip,QDialog} from 'quasar'
component.options.components = Object.assign({QItem,QInput,QBtn,QTooltip,QDialog}, component.options.components || {})
